import React from "react";
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Avatar, Box, Typography, Tooltip, } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CustomPagination from "../../../../components/CustomPagination";
import Modal from "../../../../components/Modal";

import styles from "./style";
import dayjs from "dayjs";
import { displayDateAsIs, formatDate } from "../../../../utils/DateFormat";

const AttendanceList = ({ data, handleDelete, permission, page, setPage, total, markAbsent }) => {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState();
  const deleteData = (item) => {
    setValue(item);
  }
  
  function formatTime(timestamp) {
    if (!timestamp) return "-";
    return dayjs(timestamp).format("HH:mm");
  }
  // Paid hours come from the backend so they match Schedule and Payroll — never recompute here.
  const formatPaidHours = (paidHours) => {
    if (paidHours === null || paidHours === undefined || paidHours === "") {
      return "-";
    }
    return paidHours;
  }
  const handleDeleteItem = () => {
    handleDelete(value);
    setOpen(false);
  };

  return (
    <>
      <TableContainer >
        <Box sx={{ overflowX: "auto", width: "100%" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ ...styles.TableHead, width: "15%" }}>Name</TableCell>
                <TableCell sx={{ ...styles.TableHead, width: "10%" }}>Date</TableCell>
                <TableCell sx={{ ...styles.TableHead, width: "10%" }}>Check In</TableCell>
                <TableCell sx={{ ...styles.TableHead, width: "10%" }}>Check Out</TableCell>
                <TableCell sx={{ ...styles.TableHead, width: "10%" }}>Status</TableCell>
                <TableCell sx={{ ...styles.TableHead, width: "10%" }}>Update Status</TableCell>
                <TableCell sx={{ ...styles.TableHead, width: "10%" }}>Paid Hours</TableCell>
                {permission && <TableCell sx={{ ...styles.TableHead, width: "10%" }}>Action</TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <Typography variant="h6">No data</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                data.map((item, index) => (
                  <TableRow key={item?._id || index}>
                    <TableCell sx={{ ...styles.tableAlign, width: "15%" }}>
                      <Avatar src={item.employee?.personalInfo?.image} sx={{ mr: "8px" }} />
                      <Box>
                        <Typography sx={styles.name}>{item?.employee?.personalInfo?.firstName} {item?.employee?.personalInfo?.surName}</Typography>
                        <Typography sx={styles.mail}>{item?.employee?.personalInfo?.email}</Typography>
                      </Box>
                    </TableCell>
                    <TableCell sx={{ borderBottom: 0, width: "10%",whiteSpace: "nowrap",overflow: "hidden" }}>{formatDate(item?.date)}</TableCell>
                    <TableCell sx={{ borderBottom: 0, width: "10%",whiteSpace: "nowrap",overflow: "hidden" }}>{formatTime(item?.checkin)}</TableCell>
                    <TableCell sx={{ borderBottom: 0, width: "10%",whiteSpace: "nowrap",overflow: "hidden" }}>{formatTime(item?.checkout)}</TableCell>
                    <TableCell sx={{ borderBottom: 0, width: "10%",whiteSpace: "nowrap",overflow: "hidden" }}>
                      <Box sx={{
                        border: `1px solid ${item.status === "Present" ? "#28AA4A" :
                          item.status === "Leave" ? "red" :
                            item.status === "Pending" ? "#F4B63F" :
                              item.status === "Weekend" ? "#00ABF4" : "black"}`,
                        borderRadius: "30px", display: "flex", justifyContent: "center", alignItems: "center", py: "5px", px: "14px", width: "fit-content",
                        color: `${item.status === "Present" ? "#28AA4A" :
                          item.status === "Leave" ? "red" :
                            item.status === "Pending" ? "#F4B63F" :
                              item.status === "Weekend" ? "#00ABF4" : "black"}`
                      }}>{item.status}</Box>
                    </TableCell>
                    <TableCell sx={{ borderBottom: 0, width: "10%" }}>
                      <Tooltip title={item?.status === "Present" ? "Mark employee as absent" : "Already marked absent "}>
                        <Typography sx={{
                          border: "1px solid #00ABF4",
                          borderRadius: "30px", display: "flex", justifyContent: "center", alignItems: "center", fontSize: "14px",whiteSpace: "nowrap", py: "5px", px: "14px", width: "fit-content",
                          color: "#00ABF4", cursor: "pointer"
                        }} onClick={() => { item?.status === "Present" ? markAbsent(item?._id) : console.log("") }}>
                          {item?.status === "Present" ? "Mark Absent" : "No Action"}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell sx={{ borderBottom: 0, width: "10%" }}>{formatPaidHours(item?.paidHours)}</TableCell>
                    {permission && (
                      <TableCell sx={{ ...styles.tableData, width: "10%" }}>
                        <Box sx={styles.tableIcon}>
                          <DeleteOutlineIcon sx={styles.deleteIcon} onClick={() => {
                            deleteData(item?._id || index);
                            setOpen(true);
                          }} />
                        </Box>
                      </TableCell>
                    )}
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </Box>

        <CustomPagination
          pageCount={total}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          totalItems={data.length}
        />

        {/* } */}
      </TableContainer>

      <Modal open={open} setOpen={setOpen} deletetText={"Delete"} cancelText={"Cancel"} title={"Delete Attendance"} handleDelete={handleDeleteItem}>
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>

        </Box>
      </Modal>    </>
  );
};
export default AttendanceList;
